// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"cardmembership"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 4L22 20L2 20L2 4L22 4Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M13 10L18 10L18 16L15.5 14.5L13 16L13 10Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M13 10L18 10L18 16L15.5 14.5L13 16L13 10Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 10L2 10M22 10V4L2 4L2 10M22 10V20L2 20L2 10","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CardmembershipIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'cardmembership',
    ref,
    icon: element,
  },
));

CardmembershipIcon.displayName = 'CardmembershipIcon';

export default CardmembershipIcon;
